<template>
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <strong>Events</strong>
          </div>
          <pagination-table
            :items="events"
            :is-loading="isLoading"
            :fields="[
                  {key: 'title'},
                  {key: 'status'},
                  {key: 'eventDate'},
                  {key: 'actions'},
                ]
            "
            :pagination="pagination"
            item-url="events/{id}"
          >
          </pagination-table>
        </b-card>
      </b-col>
    </b-row>
</template>

<script>
    import PaginationTable from "../../components/base/PaginationTable";
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import {PaginationMeta} from "../../models/PaginationMeta";
    export default {
        name: "Events",
        components: {
          PaginationTable,
        },
        data() {
          return {
            events: [],
            isLoading: true,
            pagination: new PaginationMeta(),
          }
        },
        created() {
          RepositoryFactory
            .get('event')
            .get()
            .then(
              response => {
                this.events = response.data.data,
                this.pagination = response.data.meta,
                this.isLoading = false
              }
            )
        }
    }
</script>

<style scoped>

</style>
